module.exports = __webpack_public_path__ + "static/media/saying goodbye2.12e4aef4.jpg";